// Default theme values from blankTheme in upsert-institution.js
export const DEFAULT_THEME_VALUES = {
    logoVertical: '/assets/icons/legacy/logo-vertical-black.png',
    logoHorizontal: '/assets/icons/legacy/logo-horizontal-black.png',
    frontColor: '#8a7b7b',
    backgroundColor: '#ffffff',
    authBoxBackground: '#ffffff',
    authBoxOpacity: '1',
    contrastFront: '#ffffff',
    sidebarTextColor: '#a8a8a8',
    behindLogoColor: '#ffffff',
    behindLogoOpacity: '1',
    verticalLogoScale: '1',
    horizontalLogoScale: '1',
    favicon: '',
    backgroundImage: '',
    contrastBack: '',
    welcomeScreenText: '',
    sidebarIconsColor: '',
};
/**
 * Same keys as `useFormik` initialValues in clinic-branding only.
 * `DEFAULT_THEME_VALUES` includes extra institution keys (e.g. sidebarIconsColor) that
 * are not editable on this page — restore-all only resets fields the user can change here.
 */
export const DEFAULT_BRANDING_FORM_VALUES = {
    frontColor: DEFAULT_THEME_VALUES.frontColor,
    backgroundColor: DEFAULT_THEME_VALUES.backgroundColor,
    contrastBack: DEFAULT_THEME_VALUES.contrastBack,
    sidebarTextColor: DEFAULT_THEME_VALUES.sidebarTextColor,
    welcomeScreenText: DEFAULT_THEME_VALUES.welcomeScreenText,
    behindLogoColor: DEFAULT_THEME_VALUES.behindLogoColor,
    logoVertical: DEFAULT_THEME_VALUES.logoVertical,
    logoHorizontal: DEFAULT_THEME_VALUES.logoHorizontal,
    favicon: DEFAULT_THEME_VALUES.favicon,
    backgroundImage: DEFAULT_THEME_VALUES.backgroundImage,
};
